var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-md-editor',{attrs:{"value":_vm.contentHtml,"mode":"preview"}})
}
var staticRenderFns = []

export { render, staticRenderFns }